<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title" #title (click)="onTitleClick()">Campaign Incentives</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list-header color="secondary" class="ion-text-wrap">
        {{incentives.length}} incentives defined.
    </ion-list-header>

    <ion-list class="ion-padding">
        <!-- <ion-reorder-group disabled="false" (ionItemReorder)="onIncentiveMove($event)"> -->
            @for (incentive of incentives; track incentive.uid) {
                <ion-item-sliding>
                <ion-item detail="true" data-test="incentive" href="javascript:;" (click)="onIncentiveClick(incentive.uid)">
                    <ion-grid>
                        <ion-row class="ion-align-items-center">
                            <!-- <ion-col size="2" size-md="1" float-center>
                                <span class="sequenceNumber">{{incentive.sequenceNumber}}</span>
                            </ion-col> -->
                            <ion-col size="9" size-md="10" class="ion-float-left">
                                <span class="line1">{{incentive.title}}</span><br />
                                @if (incentive.line1 || incentive.line2) {
                                    <div>
                                        <span class="line2">{{incentive.line1}}</span><br />
                                        <span class="line2">{{incentive.line2}}</span><br />
                                    </div>
                                    @if (incentive.note) {
                                    <div>
                                        <span class="line2">{{incentive.note}}</span><br />
                                    </div>
                                    }
                                }
                            </ion-col>
                            <!-- <ion-col size="1" class="ion-float-right">
                                @if (incentives.length > 1) {
  <ion-reorder></ion-reorder>
}
                            </ion-col> -->
                        </ion-row>
                    </ion-grid>
                </ion-item>
                <ion-item-options>
                    <ion-button data-test="deleteIncentive" id="deleteIncentive" color="danger" (click)="confirmDeleteIncentive(incentive)">
                        <ion-icon name="trash"></ion-icon>
                        Delete
                    </ion-button>
                </ion-item-options>
            </ion-item-sliding>
}
        <!-- </ion-reorder-group> -->
    </ion-list>

    <ion-fab vertical="bottom" horizontal="end" slot="fixed">
        <ion-fab-button data-test="addIncentive" [disabled]=vb.disabled id="campaignIncentive" title="Add" (click)="onCampaignIncentiveClick()">
            <ion-icon name="add"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-content>

